const MONTH_STAT_TONES = {
    emerald: "bg-success-soft text-success border-success-soft",
    sky: "bg-brand-soft text-brand border-brand-soft",
    rose: "bg-danger-soft text-danger border-danger-soft",
    amber: "bg-warning-soft text-warning border-warning-soft",
};

export function MonthStat({ label, value, tone, testId }) {
    return (
        <div
            className={`rounded-2xl border px-3 py-3 text-center ${MONTH_STAT_TONES[tone] || "bg-mist/50 text-slate-700 border-mist"}`}
            data-testid={testId}
        >
            <div className="font-display font-bold text-2xl leading-none tabular-nums">
                {value}
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.14em] mt-1 opacity-80">
                {label}
            </div>
        </div>
    );
}
